import {CreateSolicitacaoTipo} from '@components/solicitacoes/CreateSolicitacaoTipo.tsx';
import {SolicitacaoTipoInformacaoRow,} from '@components/solicitacoes/solicitacao/tipo/SolicitacaoTipoInformacao.tsx';
import {useAlert} from '@contexts/hooks/useAlert.ts';
import {_Sitemap} from '@localization/siteMap/breadcrumbs/_Sitemap.ts';
import {GetSolicitacaoTipos} from '@localization/siteMap/endpoints/_SolicitacoesEnpoints.ts';
import {IPagination} from '@localization/siteMap/siteMapInterfaces.ts';
import {DefaultPageProps} from '@models/DefaultProps.ts';
import {ISolicitacaoTipoFiltroDto} from '@models/solicitacoes/dto.ts';
import {ISolicitacaoTipo} from '@models/solicitacoes/solicitacoes.ts';
import {AddOutlined, OpenInNew} from '@mui/icons-material';
import {
    Button,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import {DefaultContainer} from '@shared/DefaultContainer.tsx';
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router';

interface SolicitacaoTiposPageProps extends DefaultPageProps {
    filtros?: ISolicitacaoTipoFiltroDto;
    slotProps?: {
        itens?: {
            EndComponent?: (value: ISolicitacaoTipo) => React.ReactNode;
        }
    };
}

export const SolicitacaoTiposPage: React.FC<SolicitacaoTiposPageProps> = (props) => {
    const {slotProps: {itens: {EndComponent} = {}} = {}} = props;
    const {addPopUp, closePopUp} = useAlert();
    const {solicitacoes} = _Sitemap;

    const [filtros, _setFiltros] = useState(props.filtros || {});
    const [tipos, setTipos] = useState<ISolicitacaoTipo[]>([]);
    const [pagination, setPagination] = useState<IPagination>({page: 0, pageSize: 10});

    const navigate = useNavigate();

    useEffect(() => {
        if (pagination.page <= 0) {
            setPagination({...pagination, page: 1});
            return;
        }

        setPagination((prev) => ({...prev, loading: true}));
        GetSolicitacaoTipos({...filtros, deveIncluir: ['Forms']}, pagination).then(x => {
            if (x.hasData) {
                setTipos(x.items);
                setPagination(prev => ({...prev, ...x.pagination}));
            }
        }).finally(() => {
            setPagination((prev) => ({...prev, loading: false, ignoreCache: false}));
        });
    }, [pagination.page, pagination.ignoreCache == true]);


    return (
        <DefaultContainer {...props} titulo={'Tipos de Solicitação'} component={Paper}
                          pageProps={{pagination, setPagination}}
                          UpperComponent={<Grid container justifyContent={'space-between'}>
                              <Grid>
                                  <Button endIcon={<AddOutlined/>} variant={'outlined'}
                                          onClick={() => {
                                              addPopUp({
                                                  title: 'Novo tipo de solicitação',
                                                  size: 'lg',
                                                  content: <CreateSolicitacaoTipo onCreate={() => {
                                                      closePopUp();
                                                      setPagination({...pagination, page: 0});
                                                  }}/>,
                                              });
                                          }}
                                  >Novo tipo de solicitação</Button>
                              </Grid>
                              <Grid/>
                          </Grid>}>

            <Grid>
                <TableContainer>
                    <Table size={'small'} stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>Id</TableCell>
                                <TableCell>Nome</TableCell>
                                <TableCell>Descrição</TableCell>
                                <TableCell align={'right'}>Ativo</TableCell>
                                <TableCell align={'right'}>Mais</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tipos.map((tipo, index) => (
                                <SolicitacaoTipoInformacaoRow key={index}
                                                              value={tipo}
                                                              EndComponent={(e) => {
                                                                  return EndComponent ? EndComponent(e) :
                                                                      <IconButton size={'small'}
                                                                                  onClick={() => {
                                                                                      navigate({
                                                                                          pathname: solicitacoes.children.tipos.children.detalhes.fullUrl,
                                                                                          search: new URLSearchParams({
                                                                                              solicitacaoTipoId: e.id.toString(),
                                                                                          }).toString(),
                                                                                      });
                                                                                  }}
                                                                      >
                                                                          <OpenInNew/>
                                                                      </IconButton>;
                                                              }}/>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

            </Grid>

        </DefaultContainer>
    );
};